// Helper function to get status badge style
const getStatusBadge = (status) => {
  switch (status) {
    case "delivered":
      return "bg-green-100 text-green-800";
    case "shipped":
      return "bg-blue-100 text-blue-800";
    case "processing":
      return "bg-yellow-100 text-yellow-800";
    case "cancelled":
      return "bg-red-100 text-red-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

// Helper function for currency formatting (assuming Turkish Lira - TL)
const formatCurrency = (amount) => {
  if (amount === undefined || amount === null) return "N/A";
  // Ensure amount is treated as a number before fixing decimals
  return `${parseFloat(amount).toFixed(2)} TL`;
};

// Helper function to format date and time (using the updated version)
const formatDateTime = (dateString) => {
  if (!dateString) return "N/A";
  return new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export { getStatusBadge, formatCurrency, formatDateTime };
